export const buildFunnelBarChartOptionsProp = (data) => {
  const dataPoints = [data.enrolledClients, data.contactedClients, data.meetingsBooked, data.receivedCoaching]
  const dropoffOffset = 48

  return {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false
        },
      },
      y: {
        grid: {
          display: false
        },
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        formatter: (value, context) => {
          const dataPoints = context.chart.data.datasets[0].data
          if (context.dataIndex < dataPoints.length - 1) {
            const nextValue = dataPoints[context.dataIndex + 1]
            const percentage = ((nextValue / value) * 100).toFixed(2)
            if (value == 0 || percentage == NaN) { return '0.00%' }

            return percentage + '%'
          }
          return ''
        },
        color: '#595F6F',
        anchor: 'end',
        align: 'right',
        offset: dropoffOffset,
        backgroundColor: (context) => {
          const index = context.dataIndex
          if (index === dataPoints.length - 1) {
            return 'transparent'
          }
          return '#EBF7FF'
        },
        borderRadius: 7,
        borderWidth: 3,
        font: { size: 11 },
        listeners: {
          beforeDraw: function (context) {
            const dataset = context.chart.getDatasetMeta(0).data
            const index = context.dataIndex

            if (index <= dataset.length - 1) {
              const bar1 = dataset[index]
              const bar2 = dataset[index + 1]

              const xPos = (bar1.x + bar2.x) / 2
              const yPos = Math.max(bar1.y, bar2.y) - dropoffOffset

              return { x: xPos, y: yPos }
            }
            return { x: 0, y: 0 }
          }
        }
      },
      flatFunnelFillPlugin: {}
    }
  }
}

export const buildWorkshopAttendanceChartOptionsProp = () => {
  return {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        grid: {
          display: false
        },
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        display: false
      },
      tooltip: {
        callbacks: {
          afterLabel: (context) => {
            const date = context.dataset.dates?.[context.dataIndex]
            return date ? `Workshop date: ${date}` : ''
          }
        }
      }
    }
  }
}
